<template>
  <v-container>
    <Title title="Dashboard"></Title>
    <v-row>
      <v-col lg="12">
        <MasterDashboard v-if="role == 'master'" />
        <AoDashboard v-if="role == 'ao'" />
        <CentreDashboard v-if="role == 'centre'" />
        <h2 v-if="role == 'learner'"></h2>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MasterDashboard from "../components/MasterDashboard";
import AoDashboard from "../components/AoDashboard";
import CentreDashboard from "../components/CentreDashboard";
import Title from "../components/Title";

export default {
  components: {
    MasterDashboard,
    AoDashboard,
    CentreDashboard,
    Title
  },
  data() {
    return {
      role: this.$store.state.role,
    };
  },
};
</script>

<style scoped>
</style>